export default "__VITE_ASSET__CmVPbBmo__"